import React__default, { useContext, createContext } from 'react';

const defaultContextValue = {
  direction: undefined,
  disabled: undefined,
  multiple: undefined,
  name: undefined,
  onSelect: undefined,
  selectedValues: undefined
};
const TileGroupContext = /*#__PURE__*/createContext(defaultContextValue);
function TileGroupContextProvider({
  direction,
  disabled,
  multiple,
  name,
  onSelect,
  selectedValues,
  children
}) {
  return /*#__PURE__*/React__default.createElement(TileGroupContext.Provider, {
    value: {
      direction,
      disabled,
      multiple,
      name,
      onSelect,
      selectedValues
    }
  }, children);
}
const useTileGroupContext = () => {
  const {
    direction,
    disabled,
    multiple,
    name,
    onSelect,
    selectedValues
  } = useContext(TileGroupContext);
  return {
    direction,
    disabled,
    multiple,
    name,
    onSelect,
    selectedValues
  };
};

export { TileGroupContextProvider as T, useTileGroupContext as u };
//# sourceMappingURL=TileGroupContext-CvSfRsxH.js.map
